import script from "./QuickActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuickActions.vue?vue&type=script&setup=true&lang=ts"

import "./QuickActions.vue?vue&type=style&index=0&id=b93acfee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b93acfee"]])

export default __exports__